<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="88.15" height="84.104" viewBox="0 0 88.15 84.104">
    <path :class="[$style.path, filled && $style.filled]" :style="`stroke-width: ${ stroke || 8 }px;`" d="M75.892,36.523,54.06,33.364,44.288,13.705a4.8,4.8,0,0,0-8.581,0L25.935,33.364,4.1,36.523a4.732,4.732,0,0,0-2.646,8.1L17.27,59.9,13.52,81.5a4.771,4.771,0,0,0,6.937,5L40,76.3l19.541,10.2a4.817,4.817,0,0,0,5.035-.362,4.721,4.721,0,0,0,1.9-4.636L62.748,59.9l15.81-15.281A4.743,4.743,0,0,0,75.892,36.523Z" transform="translate(4.075 -7.056)"/>
  </svg>
</template>

<script>
export default {
  props: {
    stroke: {type: String, required: false},
    filled: {type: Boolean, required: false},
  },
}
</script>

<style module lang="scss">
.path {
  fill: #8e85bc;
  stroke: #001722;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 8px;

  &.filled {
    fill: #fff039;
  }
}
</style>
